import { render } from "./CrudTransportador.vue?vue&type=template&id=2969903a"
import script from "./CrudTransportador.vue?vue&type=script&lang=ts"
export * from "./CrudTransportador.vue?vue&type=script&lang=ts"
script.render = render

export default script